import { ReactNode } from 'react'

import styles from './Container.module.scss'

export type ContainerProps = {
	ariaLabel?: string
	as?: keyof JSX.IntrinsicElements
	children?: ReactNode
}

export const Container = ({ children, ariaLabel, as }: ContainerProps): JSX.Element => {
	const Component = as ?? 'section'

	return (
		<Component className={styles.container} aria-label={ariaLabel}>
			{children}
		</Component>
	)
}
